/* Printer-friendly devotional print handler (FaithWise + Co).
   Lives in an external asset file so its HTML-string literals are never
   HTML-parsed (which was causing the script to render as visible text). */
function fwPrintDevotional(btn) {
  var contentEl = document.querySelector('.article-template__content');
  var contentHTML = contentEl ? contentEl.innerHTML : '';
  var title = (btn && btn.getAttribute('data-print-title')) || document.title || '';
  var dateStr = (btn && btn.getAttribute('data-print-date')) || '';
  var brand = (btn && btn.getAttribute('data-print-brand')) || '';
  var sourceUrl = (btn && btn.getAttribute('data-print-url')) || window.location.href;

  var css = '*{box-sizing:border-box}body{margin:0}'
    + '.fw-doc{max-width:700px;margin:0 auto;padding:32px 24px;font-family:Georgia,"Times New Roman",serif;color:#1a1a1a;line-height:1.65;font-size:15px}'
    + '.fw-brand{font-family:Arial,Helvetica,sans-serif;font-size:12px;letter-spacing:1px;text-transform:uppercase;color:#555;margin-bottom:20px}'
    + '.fw-doc h1{font-size:26px;line-height:1.25;margin:0 0 8px}'
    + '.fw-date{font-size:13px;color:#777;margin-bottom:24px}'
    + '.fw-content img{max-width:100%;height:auto}'
    + '.fw-content a{color:#1a1a1a;text-decoration:underline}'
    + '.fw-footer{margin-top:32px;padding-top:16px;border-top:1px solid #cccccc;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#777}'
    + '@page{margin:1.6cm}';

  var parts = [];
  parts.push('<!doctype html><html><head><meta charset="utf-8"><title>');
  parts.push(title);
  parts.push('</title><style>');
  parts.push(css);
  parts.push('</style></head><body><div class="fw-doc">');
  parts.push('<div class="fw-brand">' + brand + '</div>');
  parts.push('<h1>' + title + '</h1>');
  parts.push('<div class="fw-date">' + dateStr + '</div>');
  parts.push('<div class="fw-content">' + contentHTML + '</div>');
  parts.push('<div class="fw-footer">Read more at ' + sourceUrl + '</div>');
  parts.push('</div></body></html>');
  var docHtml = parts.join('');

  var iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  var frameDoc = iframe.contentWindow.document;
  frameDoc.open();
  frameDoc.write(docHtml);
  frameDoc.close();

  var frameWin = iframe.contentWindow;
  var printed = false;
  function fire() {
    if (printed) { return; }
    printed = true;
    frameWin.focus();
    frameWin.print();
    setTimeout(function () {
      if (iframe && iframe.parentNode) { iframe.parentNode.removeChild(iframe); }
    }, 1500);
  }
  frameWin.onload = function () { setTimeout(fire, 250); };
  setTimeout(fire, 1200);
}
